// @ts-expect-error incompatibility with node16 resolution
import {Disclosure} from '@headlessui/react';
// @ts-expect-error incompatibility with node16 resolution
import type {PortableTextBlock} from '@portabletext/types';
import clsx from 'clsx';
import type {SanityModuleAccordion} from '../../../types';
import MinusIcon from '../../icons/Minus';
import PlusIcon from '../../icons/Plus';
import PortableText from '../PortableText.client';

type Props = {
  node: PortableTextBlock & SanityModuleAccordion;
};

export default function AccordionBlock({node}: Props) {
  return (
    <section className={clsx('accordion-block')}>
      <div className={clsx('container', 'my-10 md:my-20 md:w-full')}>
        <div className={'content md:max-w-4xl'}>
          {node.title && (
            <div className={'my-10'}>
              <h2
                className={clsx(
                  node?.size == 'h2' ? 'h2' : 'h1',
                  'font-bold text-blue',
                )}
              >
                {node.title}
              </h2>
              {(node.subtitle || node.text) && (
                <div className="mt-4 max-w-[40rem] space-y-3">
                  {node.subtitle && (
                    <div
                      className={clsx(
                        node?.size == 'h2' && 'md:text-sm',
                        'p text-gray',
                      )}
                    >
                      {node.subtitle}
                    </div>
                  )}
                  {node.text && (
                    <div className="my-3 text-gray">{node.text}</div>
                  )}
                </div>
              )}
            </div>
          )}
          {node?.groups?.map((group) => (
            <Disclosure key={group._key}>
              {({open}: {open: boolean}) => (
                <div className="flex flex-col border-b border-b-blue-light">
                  <Disclosure.Button
                    className={clsx(
                      'flex items-center justify-between py-3 text-sm font-bold transition-opacity duration-200 ease-out',
                      'hover:text-darkGray',
                    )}
                    title={group.title}
                  >
                    <div className="text-left text-gray">{group.title}</div>
                    <div className="ml-4 shrink-0 text-black">
                      {open ? <MinusIcon /> : <PlusIcon />}
                    </div>
                  </Disclosure.Button>
                  <Disclosure.Panel className="pb-8 text-xs !text-blue-light">
                    <PortableText className={'nested'} blocks={group.body} />
                  </Disclosure.Panel>
                </div>
              )}
            </Disclosure>
          ))}
        </div>
      </div>
    </section>
  );
}
